<template>
  <!-- エラーを表示させるには Form コンポーネント内で利用して rules を設定すること -->
  <Field
    v-slot="{ field, errors }"
    v-model="inputValue"
    :rules="rules"
    :name="name"
    :bails="false"
  >
    <input
      :id="id"
      v-bind="field"
      class="input-form"
      :class="[
        $attrs.class,
        errors.length !== 0 ? 'field_with_errors' : '',
        showErrorMessages && errors.length !== 0 ? 'mb-8' : ''
      ]"
      type="text"
      :name="name"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :maxlength="maxLength"
      @input="onInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />
    <ErrorMessages v-if="showErrorMessages" :errors="errors" />
  </Field>
</template>

<script setup>
import { computed } from 'vue'
import { Field } from 'vee-validate'
import ErrorMessages from '~/src/js/customer/components/atoms/form/ErrorMessages.vue'

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  modelValue: {
    type: String,
    required: false,
    default: ''
  },
  value: {
    type: String,
    required: false,
    default: ''
  },
  id: {
    type: String,
    required: false,
    default: ''
  },
  autocomplete: {
    type: String,
    required: false,
    default: ''
  },
  type: {
    type: String,
    required: false,
    default: 'text'
  },
  name: {
    type: String,
    required: false,
    default: ''
  },
  placeholder: {
    type: String,
    required: false,
    default: ' '
  },
  maxLength: {
    type: String,
    required: false,
    default: null
  },
  rules: {
    type: String,
    required: false,
    default: ''
  },
  showErrorMessages: {
    type: Boolean,
    required: false,
    default: true
  }
})

const inputValue = computed(() => props.value || props.modelValue)

const emit = defineEmits(['update:modelValue', 'input', 'focus', 'blur'])
const onInput = event => {
  emit('update:modelValue', event.target.value)
  emit('input', event)
}
</script>

<style lang="scss" scoped>
.input-form {
  width: 100%;
  font-size: 1.6rem;
  outline: 0;
  background-color: $white;
  line-height: 1.6;
  border-radius: 8px;
  padding: 1.2rem 1.6rem;
  border: 1px solid $gray-3;
  box-sizing: border-box;
  display: flex;

  &:placeholder-shown {
    background: $gray-3;
  }

  &:focus {
    border: 1px solid $black;
  }
}

.field_with_errors {
  border: 1px solid $danger;
  box-sizing: border-box;
}
</style>
